import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import "./HomeAboutUsSection.css";
import aboutImage from "../../../assets/home/aboutus/idea.png";

const HomeAboutUsSection = () => {
  const ref = useRef(null);
  // Fade in/out when the section enters/exits the viewport
  const isInView = useInView(ref, { margin: "-100px 0px -100px 0px", once: false });

  return (
    <motion.section
      ref={ref}
      className="home-aboutus"
      initial={{ opacity: 0 }}
      animate={{ opacity: isInView ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <div className="aboutus-content">
        {/* Left Column: Experience box + main image */}
        <div className="aboutus-left">
          <div className="aboutus-experience-box">
            <h3>10+</h3>
            <span>Years of ASIC Excellence</span>
          </div>
          <img src={aboutImage} alt="About Us" className="aboutus-image" />
        </div>

        {/* Right Column */}
        <div className="aboutus-right">
          <span className="aboutus-label">About Us</span>
          <h2 className="aboutus-title">
            Leading Innovators in ASIC Design and Verification
          </h2>
          <p className="aboutus-description">
            Our company specializes in delivering top-tier ASIC design and verification services.
            With expertise spanning architecture definition, detailed verification, and IP integration,
            we consistently provide robust solutions tailored to the semiconductor industry's evolving needs.
          </p>
          <ul className="aboutus-list">
            <li>Comprehensive ASIC Design</li>
            <li>Expert Verification and Validation</li>
            <li>Custom IP Development</li>
            <li>Cutting-edge Technological Solutions</li>
          </ul>
          <button className="discover-btn">Read About Us</button>
        </div>
      </div>
    </motion.section>
  );
};

export default HomeAboutUsSection;